import React from "react";

export const StrategyMapIcon = ({ isActive, ...props }: SvgIconProps) => {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M7 13A6 6 0 107 1a6 6 0 000 12z"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.544 4.456L8.272 8.272 4.456 9.544l1.272-3.816 3.816-1.272z"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
